<template>
    <BasePage>
        <div class="container mt-6 mb-7 text-center">
            <div class="row justify-content-center">
                <div class="col-auto">
                    <img width="300" src="/LarkhallOrderConfirmed.svg">
                    <h1 class="mt-6">Payment Successful</h1>
                    <p>Thank you for paying your remaining balance, Merry Christmas!</p>
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>


import BasePage from '@/components/BasePage.vue';  // Adjust the import path if necessary

export default {
    name: 'BalanceSuccessPage',
    components: {
        BasePage,
    },
    mounted() {
        document.title = "Balance Paid | Larkhall Butchers"
    }
};
</script>
